import React, { useState, useEffect } from 'react';
import './Report.css'; // Assuming you will create a CSS file for styles
import ToasterS from '../../Customer Panel/Toaster'; // Import success toaster
import ToasterF from '../../Customer Panel/ToasterF'; // Import failure toaster
import pdfdownload from './pdf-download.svg';
import Paginate from '../../Pagegnation/Pagination'; // Import Pagination component
import LoadingSpinner from '../../Loader/Loader';
import api from '../../../api';

const CompletedOrderReport = () => {
  // State for holding fetched data, date selectors, and toast messages
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [toastMessage, setToastMessage] = useState("");
  const [showToastFail, setShowToastFail] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false); // State to handle loading

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // 10 items per page
  const [totalItems, setTotalItems] = useState(0); // Total records from the backend

  // Function to get today's date in 'YYYY-MM-DD' format
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Function to get the first day of the current month in 'YYYY-MM-DD' format
  const getStartOfMonth = () => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return startOfMonth.toISOString().split('T')[0];
  };

  // Set default dates when the component mounts
  useEffect(() => {
    const today = getTodayDate();
    const startOfMonth = getStartOfMonth();
    setStartDate(startOfMonth); // Set start date to the first day of the current month
    setEndDate(today); // Set end date to today's date
    handleDateSubmit(startOfMonth, today, currentPage); // Fetch data from the first day of the month to today
  }, []);

  // Function to handle the button click and send start/end dates
  const handleDateSubmit = (start = startDate, end = endDate, page = currentPage) => {
    setLoading(true); // Start loading
    const payload = {
      start_date: start,
      end_date: end,
      report_type: 'completed',
      page: page, // Send the current page
      records_per_page: itemsPerPage // Number of records per page
    };

    api.post('/generate_customerReport.php', payload)
      .then(response => {
        setLoading(false); // Stop loading
        if (Array.isArray(response.data.data)) {
          if (response.data.data.length === 0) {
            setToastMessage("Data not found");
            setShowToastFail(true);
          } else {
            setData(response.data.data);
            setToastMessage("Data retrieved successfully");
            setShowToast(true);
            setTotalItems(response.data.totalRecords); // Set total items for pagination
          }
        } else {

          setData([]); // Reset data in case of invalid response
          setToastMessage("Unexpected response format");
          setShowToastFail(true);
        }
      })
      .catch(error => {
        setLoading(false); // Stop loading
        setToastMessage("An error occurred while fetching data");
        setShowToastFail(true);
      });
  };

  // Handle PDF download
  const handleDownloadPdf = () => {
    if (!data || data.length === 0) {
      setToastMessage("Data not found. PDF cannot be downloaded.");
      setShowToastFail(true);
      return; // Exit if there's no data
    }

    const payload = {
      start_date: startDate,
      end_date: endDate,
    };

    setLoading(true); // Start loading for PDF download
    api.post('/Completedcuspdf.php', payload, {
      responseType: 'blob', // Important to handle binary data
    })
      .then(response => {
        setLoading(false); // Stop loading
        // Create a URL for the PDF blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Completed_Customer_report.pdf'); // Specify the name of the file
        document.body.appendChild(link);
        link.click(); // Simulate click to trigger download
        link.remove(); // Clean up
        setToastMessage("PDF downloaded successfully");
        setShowToast(true);
      })
      .catch(error => {
        setLoading(false); // Stop loading
        setToastMessage("An error occurred while downloading PDF");
        setShowToastFail(true);
      });
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleDateSubmit(startDate, endDate, page); // Fetch data with the new page
  };

  if(loading){
    return(
      <LoadingSpinner/>
    )
  }
  return (
    <div className="Report_Admin_Page_container">
      <ToasterS
        message={toastMessage}
        show={showToast}
        onClose={() => setShowToast(false)}
      />
      <ToasterF
        message={toastMessage}
        show={showToastFail}
        onClose={() => setShowToastFail(false)}
      />

      <h2 className="Report_Admin_Page_heading">Completed Customer Reports</h2>

      {/* Date selectors */}
      <div className="Report_Admin_Page_dateSelectors">
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="Report_Admin_Page_input"
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="Report_Admin_Page_input"
          />
        </label>
        {/* Submit button */}
        <div className="Report_Admin_Page_buttonContainer">
          <button onClick={() => handleDateSubmit()} className="Report_Admin_Page_button">
            Submit Dates
          </button>
        </div>

        <div className="Report_Admin_Page_buttonContainer">
          <img
            src={pdfdownload}
            alt="Download PDF"
            onClick={handleDownloadPdf}
            className="Report_Admin_Page_downloadGif"
          />
        </div>
      </div>

      {/* Show spinner while loading */}
      {loading && (
        <div className="loading-spinner40">
          <div className="spinner"></div>
        </div>
      )}

      {/* Table for displaying fetched data */}
      <table className="Report_Admin_Page_table">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Address</th>
            <th>Issue</th>
            <th>Therapy</th>
            <th>Age</th>
            <th>Gender</th>
            <th>PrefGender</th>
            <th>Booking Time</th>
            <th>Appointment</th>
            <th>Massager Name</th>

          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data
              .slice()
              .sort((a, b) => new Date(b.time) - new Date(a.time))
              .map((entry, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{entry.customer_name}</td>
                  <td>{entry.customer_contact}</td>
                  <td>{entry.customer_email}</td>
                  <td>{entry.customer_address}</td>
                  <td>{entry.customer_issue}</td>
                  <td>{entry.customer_therapy}</td>
                  <td>{entry.age}</td>
                  <td>{entry.customer_gender}</td>
                  <td>{entry.prefgender}</td>
                  <td>{entry.request_time}</td>
                  <td>{entry.appointment}</td>
                  <td>{entry.massager_name}</td>

                </tr>
              ))
          ) : (
            <tr>
              <td colSpan="7">No data available</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Component */}
      <Paginate
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CompletedOrderReport;
